export default {"src":"/_next/static/media/published-data-blob-1.06bfca4d.svg","height":320,"width":220,"blurWidth":0,"blurHeight":0};